<template>
	<div>
		<veneer-log :log="getConcreteItem(item)"
					:watchlist-item="item"
					:virtual="isItemVirtual(item)"
					:is-public="isPublic"
					:measurement-list-dialog="true"
					:watchlist-dialog="true"
		>
			<template v-slot:additionalInfo>
        <q-separator spaced/>

        <div class="q-py-md">
          <div class="row">
            <template v-if="user && !isPublic">
              <div class="col-12">
                <span class="text-h5">{{ $t('furtherInformation') }}</span>
              </div>
              <div class="col-12">
                <q-input type="number"
                     v-model="newPrice"
                     :prefix="$t('label.price')"
                     :suffix="priceUnit"
                     input-class="text-right"
                />
              </div>
              <div class="col-12">
                <q-input v-model="newDescription"
                     :placeholder="$t('addDescription')"
                     :label="$t('label.comment')"
                     autogrow
                />
              </div>
            </template>
            <template v-else>
              <div class="col-12" v-if="item.price">
                {{ $t('label.price') }}: {{ item.price | currency }}
              </div>
              <div class="col-12" v-if="item.description">
                {{ item.description }}
              </div>
            </template>
          </div>
        </div>
			</template>

			<template v-slot:additionalActions v-if="!isPublic">
        <div class="col-4">
          <q-btn @click="removeFromWatchlist" v-if="user" icon="delete" text-color="primary" no-caps flat size="11px" :label="$t('button.remove')"/>
        </div>
        <div class="col-4">
          <q-btn @click.stop="showLogImagesDialog" v-if="user" icon="photo" text-color="primary" no-caps flat size="11px" :label="$t('tooltip.setWatchlistItemLogImages')"/>
        </div>
			</template>

		</veneer-log>
	</div>
</template>

<script>
	import {mapGetters, mapMutations} from 'vuex';
	import VeneerLog from "@/components/common/VeneerLog";
	import {REMOVE_FROM_WATCHLIST, UPDATE_WATCHLIST_ITEM} from "@/store/actions.type";
	import NumberFormattingFilters from "@/mixins/NumberFormattingFilters";
	import LogUtility from "@/mixins/LogUtility";
	import {SHOW_DIALOG} from "@/store/mutations.type";
	import {CURRENCIES} from "@/common/constants";
	import debounce from 'debounce';

	export default {
		name: "WatchlistItem",
		components: {VeneerLog},
		mixins: [NumberFormattingFilters, LogUtility],
		props: ['item', 'isPublic'],
		data() {
			return {
				newDescription: this.item.description,
				newPrice: NumberFormattingFilters.filters.number(this.item.price, "en-US", 2, 2)
			}
		},
		computed: {
			...mapGetters(['watchlist', 'user']),
			priceUnit() {
				return `${CURRENCIES[this.watchlist.currency]}${this.$t('unit.perSqm')}`;
			}
		},
		created() {
			this.debouncedUpdateItem = debounce(this.updateItem, 800);
		},
		watch: {
			newPrice() {
				this.debouncedUpdateItem();
			},
			newDescription() {
				this.debouncedUpdateItem();
			}
		},
		methods: {
			...mapMutations([SHOW_DIALOG]),
			removeFromWatchlist() {
				this.$q.dialog({
					title: this.$t('button.remove'),
					message: this.$t('confirmationText.deleteWatchlistItem'),
					cancel: true,
					persistent: true
				}).onOk(async () => {
					await this.$store.dispatch(REMOVE_FROM_WATCHLIST, {
						watchlist: this.watchlist,
						item: this.item
					});
				});
			},
			async updateItem() {
				await this.$store.dispatch(UPDATE_WATCHLIST_ITEM, {
					object: this.item,
					watchlist: this.watchlist,
					props: {
						description: this.newDescription,
						price: this.newPrice
					},
					hideSuccess: true
				});
			},
			showLogImagesDialog() {
        const isVirtual = this.item.virtual !== null;
				this[SHOW_DIALOG]({
					component: 'LogImagesPicker',
					item: this.item,
					contentClass: 'large-dialog',
					showBundleViewer: true,
          isVirtual: isVirtual
				});
			}
		}
	}
</script>